// Anita Week 8 / Day 5 — Week Project: Mini Nature Atlas.
// Verbatim from FINAL Week 8 Part B source-of-truth package. No invention.
// SAFETY: paper atlas only; parentGuide forbids touching unknown organisms
// or going outside alone. The classify task lists unsafe nature actions
// only as items to classify, never as instructions.

const day5 = {
  id: 'day-5',
  studentId: 'anita',
  weekId: 'week-8',
  dayId: 'day-5',
  status: 'active',
  title: 'Проект недели: мини-атлас природы / Week Project: Mini Nature Atlas',
  shortTitle: 'Мини-атлас природы / Mini Nature Atlas',
  theme:
    'Анита собирает мини-атлас природы: живое и неживое, растение, животное, среда, связь, данные и вывод. / Anita creates a mini nature atlas.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'science', 'project', 'nature-atlas', 'data', 'spelling', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro:
    'Нимни открывает папку природы. Сегодня Анита соберёт мини-атлас: обложку, карточку живого и неживого, страницу растения, страницу животного, среду обитания, связь в природе, данные и вывод. / Nimny opens a nature folder. Today Anita creates a mini atlas: cover, living/nonliving card, plant page, animal page, habitat, nature connection, data and conclusion.',
  goals: [
    'Повторить идеи Week 8. / Review Week 8 ideas.',
    'Сделать мини-атлас природы. / Create a Mini Nature Atlas.',
    'Решить смешанные задачи с ×, ÷, таблицами и графиком. / Mixed math with multiplication, division, tables, graph.',
    'Повторить правила безопасного наблюдения природы. / Review safe nature observation rules.',
    'Объяснить проект родителю по-русски. / Explain project to parent in Russian.'
  ],
  vocabulary: [
    { term: 'живое / living', definition: 'организм. / an organism.' },
    { term: 'неживое / nonliving', definition: 'не живёт как организм. / does not live like an organism.' },
    { term: 'растение / plant', definition: 'живой организм, который растёт. / a growing organism.' },
    { term: 'корень / root', definition: 'часть растения в земле. / part in the soil.' },
    { term: 'стебель / stem', definition: 'держит растение. / holds the plant.' },
    { term: 'лист / leaf', definition: 'получает свет. / captures light.' },
    { term: 'цветок / flower', definition: 'из него могут появиться семена. / where seeds appear.' },
    { term: 'животное / animal', definition: 'двигается, ест и растёт. / moves, eats and grows.' },
    { term: 'среда / habitat', definition: 'место, где живёт организм. / where an organism lives.' },
    { term: 'связь / connection', definition: 'когда одно помогает другому. / when one helps another.' },
    { term: 'цепочка / chain', definition: 'связанные шаги. / connected steps.' },
    { term: 'данные / data', definition: 'числа и наблюдения. / numbers and observations.' },
    { term: 'вывод / conclusion', definition: 'что я поняла. / what I understood.' },
    { term: 'безопасность / safety', definition: 'правила, чтобы не навредить себе или природе. / safety rules.' }
  ],
  onlineTasks: [
    {
      id: 'reading-review-words',
      type: 'text',
      title: 'Задание 1 — Слова мини-атласа / Mini Atlas Words',
      prompt: 'Прочитай слова недели:\nживое\nнеживое\nрастение\nкорень\nстебель\nлист\nцветок\nживотное\nсреда\nсвязь\nцепочка\nданные\nвывод\nбезопасность',
      ruPrimaryText: 'Прочитай 14 русских слов мини-атласа.',
      enHelpText: 'Read the Russian nature atlas words first. English is only for help.',
      answer: 'Анита пробует читать русские слова. / Anita attempts the Russian reading.'
    },
    {
      id: 'oral-defense-reading',
      type: 'text',
      title: 'Задание 2 — Фразы натуралиста / Naturalist Phrases',
      prompt: 'Прочитай и попробуй сказать по-русски:\n1. Я наблюдаю природу безопасно.\n2. Я отличаю живое и неживое.\n3. Я знаю части растения.\n4. Я могу описать животное и среду.\n5. Я вижу связи в природе.\n6. Я делаю вывод по данным.',
      ruPrimaryText: 'Прочитай и устно произнеси 6 фраз натуралиста.',
      enHelpText: 'Read and say aloud 6 naturalist phrases.',
      answer: 'Анита пробует читать и говорить 6 фраз. / Anita attempts the reading and oral speaking.'
    },
    {
      id: 'math-week5-review',
      type: 'text',
      title: 'Задание 3 — Математическая проверка / Math Review',
      prompt:
        'Реши задачи.\n\n1. В атласе 4 страницы. На каждой странице по 3 рисунка. Сколько рисунков?\n2. Анита нарисовала 24 листа и разделила их поровну на 6 растений. Сколько листьев у каждого растения?\n3. В таблице: растения — 8, насекомые — 6, птицы — 3, животные у пруда — 9. Сколько всего?\n4. В саду 5 групп цветов, в каждой группе по 4 цветка. Сколько цветов?\n5. В атласе 7 разделов. Анита закончила 4. Сколько осталось?\n6. На графике 30 значков природы разделили на 5 равных строк. Сколько значков в строке?',
      ruPrimaryText: 'Реши 6 смешанных задач недели (умножение, деление, сложение, вычитание).',
      enHelpText: '6 mixed math review questions.',
      answer: '1) 4 × 3 = 12. 2) 24 ÷ 6 = 4. 3) 8 + 6 + 3 + 9 = 26. 4) 5 × 4 = 20. 5) 7 − 4 = 3. 6) 30 ÷ 5 = 6.'
    },
    {
      id: 'atlas-cover-plan',
      type: 'text',
      title: 'Задание 4 — Обложка атласа / Atlas Cover',
      prompt:
        'Создай обложку мини-атласа.\n\nНа обложке должны быть:\n1. Название: «Мини-атлас природы Нимни».\n2. Автор: Анита.\n3. 4 маленьких рисунка: растение, животное, вода, солнце.\n4. Одна фраза: «Я наблюдаю природу безопасно.»',
      ruPrimaryText: 'Сделай обложку: название, автор, 4 рисунка и фраза безопасности.',
      enHelpText: 'Create the cover: title, author, 4 drawings, safety phrase.',
      answer: 'Open-ended. Accept if cover includes title, author, four drawings, and safety phrase.'
    },
    {
      id: 'nature-safety-sort',
      type: 'classify',
      title: 'Задание 5 — Безопасно или нельзя? / Safe or Not Allowed?',
      prompt:
        'Разложи карточки по категориям.\n\nКатегории:\nБезопасно с родителем\nНельзя в природе Нимни\n\nКарточки:\n1. Нарисовать растение по картинке.\n2. Смотреть на дерево из окна.\n3. Сорвать незнакомый гриб.\n4. Покормить дикое животное.\n5. Нарисовать животное из книги.\n6. Потрогать незнакомое насекомое.\n7. Спросить родителя о погоде.\n8. Попробовать ягоду с улицы.\n9. Сделать таблицу наблюдений.\n10. Пойти одной искать животных.\n11. Нарисовать цепочку природы.\n12. Рассмотреть лист с родителем, если родитель разрешил и это безопасно.',
      ruPrimaryText: 'Разложи 12 карточек: безопасно с родителем / нельзя в природе Нимни.',
      enHelpText: 'Sort 12 cards: safe-with-parent / not-allowed.',
      categories: [
        { id: 'safe-with-parent', label: 'Безопасно с родителем / Safe with parent' },
        { id: 'not-allowed', label: 'Нельзя в природе Нимни / Not allowed' }
      ],
      items: [
        { id: 'i1', label: 'Нарисовать растение по картинке.', category: 'safe-with-parent' },
        { id: 'i2', label: 'Смотреть на дерево из окна.', category: 'safe-with-parent' },
        { id: 'i3', label: 'Сорвать незнакомый гриб.', category: 'not-allowed' },
        { id: 'i4', label: 'Покормить дикое животное.', category: 'not-allowed' },
        { id: 'i5', label: 'Нарисовать животное из книги.', category: 'safe-with-parent' },
        { id: 'i6', label: 'Потрогать незнакомое насекомое.', category: 'not-allowed' },
        { id: 'i7', label: 'Спросить родителя о погоде.', category: 'safe-with-parent' },
        { id: 'i8', label: 'Попробовать ягоду с улицы.', category: 'not-allowed' },
        { id: 'i9', label: 'Сделать таблицу наблюдений.', category: 'safe-with-parent' },
        { id: 'i10', label: 'Пойти одной искать животных.', category: 'not-allowed' },
        { id: 'i11', label: 'Нарисовать цепочку природы.', category: 'safe-with-parent' },
        { id: 'i12', label: 'Рассмотреть лист с родителем, если родитель разрешил и это безопасно.', category: 'safe-with-parent' }
      ],
      answer: 'Безопасно с родителем: 1, 2, 5, 7, 9, 11, 12. Нельзя в природе Нимни: 3, 4, 6, 8, 10.'
    },
    {
      id: 'data-atlas-graph',
      type: 'text',
      title: 'Задание 6 — График мини-атласа / Mini Atlas Graph',
      prompt:
        'В мини-атласе Аниты:\n\nрастения — 6 рисунков\nживотные — 5 рисунков\nнеживое — 4 рисунка\nсвязи природы — 3 рисунка\n\nОтветь:\n1. Каких рисунков больше всего?\n2. На сколько растений больше, чем связей природы?\n3. Сколько всего рисунков в атласе?\n4. Если добавить ещё 2 животных, сколько животных станет?',
      ruPrimaryText: 'Прочитай данные мини-атласа и ответь на 4 вопроса.',
      enHelpText: 'Atlas data: plants 6, animals 5, nonliving 4, connections 3. Answer 4 questions.',
      answer: '1) Растений. 2) 6 − 3 = 3. 3) 6 + 5 + 4 + 3 = 18. 4) 5 + 2 = 7.'
    },
    {
      id: 'project-mini-nature-atlas',
      type: 'project',
      title: 'Задание 7 — Мой мини-атлас природы / My Mini Nature Atlas',
      prompt:
        'Создай проект «Мини-атлас природы».\n\nВ проекте должны быть 7 разделов:\n\n1. Обложка атласа.\n2. Живое и неживое.\n3. Страница растения: корень, стебель, лист, цветок.\n4. Страница животного: группа, признаки, среда.\n5. Связь в природе: солнце, вода, растение, животное.\n6. Данные или мини-график.\n7. Мой вывод и правило безопасности.\n\nПиши коротко по-русски. Можно рисовать.\n\nВажно:\nНе трогай незнакомые растения или животных.\nНе ешь ничего найденного.\nНе выходи одна для наблюдения.',
      ruPrimaryText: 'Сделай мини-атлас из 7 разделов на бумаге, без сбора живых организмов.',
      enHelpText: 'Make a 7-section mini atlas on paper, without collecting living organisms.',
      hint: 'Атлас бумажный — рисуй по картинкам или из окна. / Paper atlas only; draw from pictures or from a window.',
      answer: 'Open-ended project. Must include most sections, drawings/labels, one data element, one conclusion, and one safety rule.'
    },
    {
      id: 'spelling-review',
      type: 'text',
      title: 'Задание 8 — Правописание недели / Week Spelling',
      prompt: 'Напиши 7 слов на выбор:\nживое\nнеживое\nрастение\nкорень\nлист\nцветок\nживотное\nсреда\nсвязь\nданные\nвывод',
      ruPrimaryText: 'Напиши 7 слов недели на выбор.',
      enHelpText: 'Write any 7 of the week words.',
      answer: 'Любые 7 попыток. Правильные формы: живое, неживое, растение, корень, лист, цветок, животное, среда, связь, данные, вывод.'
    },
    {
      id: 'speech-atlas-defense',
      type: 'text',
      title: 'Задание 9 — Защита проекта / Project Defense',
      prompt:
        'Объясни родителю по-русски:\n\n1. Что есть на обложке атласа?\n2. Чем живое отличается от неживого?\n3. Какие части растения ты знаешь?\n4. Какое животное ты описала?\n5. Какая связь в природе есть в твоём атласе?\n6. Какой вывод ты сделала?\n7. Какое правило безопасности ты соблюдала?',
      ruPrimaryText: 'Защити проект родителю: ответь на 7 вопросов по-русски.',
      enHelpText: 'Defend the project to parent: answer 7 questions in Russian.',
      answer: 'Accept if Anita explains at least 4 parts of the atlas in Russian with support.'
    }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши название «Мини-атлас природы».',
    '2. Напиши 7 слов недели.',
    '3. Прочитай 6 фраз натуралиста.',
    '4. Реши 6 math-задач.',
    '5. Сделай обложку атласа.',
    '6. Нарисуй 7 разделов мини-атласа.',
    '7. Добавь данные или мини-график.',
    '8. Напиши вывод и правило безопасности.',
    '9. Объясни проект родителю.'
  ],
  printWorksheet: {
    title: 'Проект недели: мини-атлас природы / Week Project: Mini Nature Atlas',
    subtitle: 'Неделя 8 · День 5 / Week 8 · Day 5',
    pages: [
      {
        title: 'Обложка и слова / Cover and Words',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Задание 1 — Слова мини-атласа. Прочитай и обведи:' },
          { type: 'list', items: [
            'живое / living',
            'неживое / nonliving',
            'растение / plant',
            'корень / root',
            'стебель / stem',
            'лист / leaf',
            'цветок / flower',
            'животное / animal',
            'среда / habitat',
            'связь / connection',
            'цепочка / chain',
            'данные / data',
            'вывод / conclusion',
            'безопасность / safety'
          ] },
          { type: 'text', text: 'Задание 2 — Фразы натуралиста (чтение и устная речь / reading and speaking). Поставь галочку:' },
          { type: 'list', items: [
            '□ Я наблюдаю природу безопасно.',
            '□ Я отличаю живое и неживое.',
            '□ Я знаю части растения.',
            '□ Я могу описать животное и среду.',
            '□ Я вижу связи в природе.',
            '□ Я делаю вывод по данным.'
          ] },
          { type: 'text', text: 'Задание 4 — Обложка атласа. Название: Мини-атлас природы Нимни. Автор: Анита.' },
          { type: 'list', items: [
            'Нарисуй 4 маленьких рисунка: □ растение  □ животное  □ вода  □ солнце',
            'Фраза: Я наблюдаю природу безопасно. __________________________'
          ] }
        ]
      },
      {
        title: 'Математика, безопасность и график / Math, Safety and Graph',
        blocks: [
          { type: 'text', text: 'Задание 3 — Математическая проверка (умножение, деление, сложение, вычитание):' },
          { type: 'list', items: [
            '1. 4 страницы × 3 рисунка = ______',
            '2. 24 листа ÷ 6 растений = ______',
            '3. 8 + 6 + 3 + 9 = ______',
            '4. 5 групп цветов × 4 цветка = ______',
            '5. 7 разделов − 4 готово = ______',
            '6. 30 значков ÷ 5 строк = ______'
          ] },
          { type: 'text', text: 'Задание 5 — Безопасно или нельзя? Напиши Б = безопасно с родителем, Н = нельзя.' },
          { type: 'list', items: [
            '1. Нарисовать растение по картинке. ____',
            '2. Смотреть на дерево из окна. ____',
            '3. Сорвать незнакомый гриб. ____',
            '4. Покормить дикое животное. ____',
            '5. Нарисовать животное из книги. ____',
            '6. Потрогать незнакомое насекомое. ____',
            '7. Спросить родителя о погоде. ____',
            '8. Попробовать ягоду с улицы. ____',
            '9. Сделать таблицу наблюдений. ____',
            '10. Пойти одной искать животных. ____',
            '11. Нарисовать цепочку природы. ____',
            '12. Рассмотреть лист с родителем, если родитель разрешил и это безопасно. ____'
          ] },
          { type: 'text', text: 'Задание 6 — График мини-атласа. растения — 6 рисунков, животные — 5 рисунков, неживое — 4 рисунка, связи природы — 3 рисунка.' },
          { type: 'list', items: [
            '1. Больше всего рисунков: __________________________',
            '2. Растений больше, чем связей, на: ______',
            '3. Всего рисунков: ______',
            '4. Если добавить 2 животных: ______'
          ] }
        ]
      },
      {
        title: 'Мой мини-атлас и защита / My Mini Atlas and Defense',
        blocks: [
          { type: 'text', text: 'Задание 7 — Мой мини-атлас природы. В проекте должны быть 7 разделов:' },
          { type: 'list', items: [
            '□ 1. Обложка атласа.',
            '□ 2. Живое и неживое.',
            '□ 3. Страница растения: корень, стебель, лист, цветок.',
            '□ 4. Страница животного: группа, признаки, среда.',
            '□ 5. Связь в природе: солнце, вода, растение, животное.',
            '□ 6. Данные или мини-график.',
            '□ 7. Мой вывод и правило безопасности.'
          ] },
          { type: 'text', text: 'Рамка для рисунка / карты атласа: ________________________________________________________ ________________________________________________________ ________________________________________________________ ________________________________________________________' },
          { type: 'text', text: 'Мой вывод: __________________________________________________________' },
          { type: 'text', text: 'Моё правило безопасности: __________________________________________________________' },
          { type: 'text', text: 'Задание 8 — Правописание недели. Напиши 7 слов на выбор: живое, неживое, растение, корень, лист, цветок, животное, среда, связь, данные, вывод.' },
          { type: 'list', items: [
            '1. __________________________',
            '2. __________________________',
            '3. __________________________',
            '4. __________________________',
            '5. __________________________',
            '6. __________________________',
            '7. __________________________'
          ] },
          { type: 'text', text: 'Задание 9 — Защита проекта. Ответь устно родителю:' },
          { type: 'list', items: [
            '□ Что есть на обложке атласа?',
            '□ Чем живое отличается от неживого?',
            '□ Какие части растения ты знаешь?',
            '□ Какое животное ты описала?',
            '□ Какая связь в природе есть в твоём атласе?',
            '□ Какой вывод ты сделала?',
            '□ Какое правило безопасности ты соблюдала?'
          ] },
          { type: 'text', text: 'Parent Check: □ прочитала слова недели  □ прочитала фразы натуралиста  □ решила math review  □ проверила безопасность  □ сделала обложку  □ собрала мини-атлас  □ объяснила проект родителю.' },
          { type: 'text', text: 'Notebook Mode fallback — если нет принтера, сделай все 9 заданий в тетради по тем же номерам.' }
        ]
      }
    ]
  },
  parentGuide: {
    goal: 'Анита собирает Week 8 в проект «Мини-атлас природы» и объясняет его родителю.',
    mathGoal: 'Смешанное повторение: умножение (4 × 3, 5 × 4), деление (24 ÷ 6, 30 ÷ 5), сложение, вычитание, таблица данных, график.',
    russianGoal: 'Прочитать 14 слов недели и 6 фраз натуралиста.',
    readingWritingGoal: 'Прочитать фразы, написать 7 слов, заполнить короткие разделы атласа.',
    practicalGoal: 'Создать мини-атлас с обложкой, страницами природы, данными, выводом и правилом безопасности.',
    parentTheoryCard: {
      title: 'Как провести проект «Мини-атлас природы»',
      purpose: 'Помочь родителю превратить неделю наблюдений в понятный детский научно-творческий артефакт.',
      keyMessage: 'Мини-атлас — это не просто рисунки. Это способ собрать знания: классификация, растение, животное, среда, связь, данные, вывод и безопасность.',
      parentScript: [
        '«Сегодня ты собираешь свою маленькую книгу природы.»',
        '«В атласе важно не только красиво рисовать, но и объяснить.»',
        '«Каждая страница показывает одну идею недели.»',
        '«Правило безопасности — часть работы натуралиста.»',
        '«Хороший атлас помогает другому человеку понять природу.»'
      ],
      practiceSteps: [
        'Начните с обложки.',
        'Выберите одну страницу живого/неживого.',
        'Добавьте растение и подпишите части.',
        'Добавьте животное и среду.',
        'Добавьте связь в природе.',
        'Добавьте данные или график.',
        'Попросите Аниту объяснить 3–4 раздела по-русски.'
      ],
      doNotSay: [
        'Не говорить: «Это просто рисунок.»',
        'Не требовать профессионального атласа.',
        'Не сравнивать с Максимом.',
        'Не заставлять ребёнка писать длинные тексты.',
        'Не просить собирать реальные растения или животных.'
      ],
      paperOnlyNotes: [
        'Атлас можно сделать полностью в тетради.',
        'Обложка может быть отдельной страницей.',
        'Можно использовать рисунки, карточки и короткие подписи.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится собирать знания в проект и объяснять результат.',
    keyMessage: 'Я могу наблюдать, классифицировать, рисовать, считать, делать вывод и объяснять.',
    howToExplain: 'Скажите: «Атлас — это книга, которая помогает другому человеку узнать о природе. Ты создаёшь не просто рисунок, а полезный материал.»',
    exampleDialogue:
      'Parent: Что на первой странице атласа?\nChild: Живое и неживое.\nParent: Что на странице растения?\nChild: Корень, стебель, лист, цветок.\nParent: Что показывает связь?\nChild: Солнце, вода, растение, животное.\nParent: Какой вывод?\nChild: В природе всё связано.',
    readingSupport: 'Слова «безопасность», «классификация», «наблюдение» можно читать по частям.',
    russianSpeechGoal: 'Анита объясняет минимум 4 раздела атласа по-русски.',
    mathAnswerKey:
      'math-week5-review: 1) 12. 2) 4. 3) 26. 4) 20. 5) 3. 6) 6.\ndata-atlas-graph: 1) Растений. 2) 3. 3) 18. 4) 7.\nnature-safety-sort: Безопасно: 1,2,5,7,9,11,12; Нельзя: 3,4,6,8,10.',
    spellingAnswerKey: 'Правильные формы:\nживое\nнеживое\nрастение\nкорень\nлист\nцветок\nживотное\nсреда\nсвязь\nданные\nвывод',
    answerKey: [
      { taskId: 'reading-review-words', answer: 'Попытка русского чтения 14 слов.' },
      { taskId: 'oral-defense-reading', answer: 'Попытка чтения и/или устного произнесения 6 фраз.' },
      { taskId: 'math-week5-review', answer: '12; 4; 26; 20; 3; 6.' },
      { taskId: 'atlas-cover-plan', answer: 'Обложка с названием, автором, 4 рисунками и фразой безопасности.' },
      { taskId: 'nature-safety-sort', answer: 'Безопасно: 1,2,5,7,9,11,12; Нельзя: 3,4,6,8,10.' },
      { taskId: 'data-atlas-graph', answer: 'Растений; 3; 18; 7.' },
      { taskId: 'project-mini-nature-atlas', answer: 'Атлас из 7 разделов с правилом безопасности.' },
      { taskId: 'spelling-review', answer: 'Любые 7 попыток слов.' },
      { taskId: 'speech-atlas-defense', answer: 'Защита проекта: минимум 4 раздела по-русски.' }
    ],
    check: [
      'Анита прочитала слова недели.',
      'Анита прочитала или сказала фразы натуралиста.',
      'Анита решила math review.',
      'Анита отсортировала safety cards.',
      'Анита сделала обложку.',
      'Анита собрала мини-атлас.',
      'Анита объяснила проект родителю.'
    ],
    spellingCheck: 'Проверить 7 выбранных слов. Исправлять мягко.',
    readingCheck: 'Главное — попытка русского чтения и понимание смысла.',
    practicalCheck: 'Атлас должен иметь обложку, минимум 5 разделов, один вывод и правило безопасности.',
    projectCriteria: '1) Обложка. 2) Страница живое/неживое. 3) Страница растения. 4) Страница животного/среды. 5) Страница связи в природе. 6) Данные или график. 7) Вывод и правило безопасности.',
    rubric:
      'Russian reading attempt — 15 points.\nRussian oral explanation — 15 points.\nMath review correctness — 15 points.\nNature understanding — 20 points.\nSafety rule — 10 points.\nProject completeness — 15 points.\nCreativity / neatness — 5 points.\nEffort and focus — 5 points.',
    commonMistakes: [
      '«Атлас — это только красивый рисунок.» Правильно: «Атлас объясняет знания.»',
      '«Можно писать много английского.» Правильно: «Русский основной, английский только помощь.»',
      '«Можно потрогать всё в природе.» Правильно: «Наблюдать безопасно, не трогать неизвестное.»',
      '«Вывод не нужен.» Правильно: «Вывод показывает, что я поняла.»'
    ],
    discussionPrompts: [
      'Какая страница атласа самая важная?',
      'Что ты узнала о растениях?',
      'Что ты узнала о животных?',
      'Какая связь в природе тебе понятна?',
      'Какое правило безопасности ты запомнила?'
    ],
    ifEasy: 'Попросить Аниту провести 2-минутную презентацию атласа по-русски.',
    ifDifficult: 'Пусть Анита сделает 4 основные страницы: обложка, растение, животное, вывод.',
    rewardGuidance: 'Проектный день: базовая награда 5 нимов. Бонусы за чтение, объяснение и аккуратный мини-атлас.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не требовать длинных текстов. Цель — собрать знания недели в понятный артефакт.',
    safetyNotes: 'Не трогать незнакомые растения, грибы, насекомых или животных. Не есть ничего найденного. Не кормить животных. Не выходить одной для наблюдения.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 5,
    max: 8,
    label: 'Награда за проект',
    display: '5 нимов',
    bonuses: [
      { id: 'good-russian-reading', label: 'Бонус за хорошую попытку русского чтения', amount: 1 },
      { id: 'clear-parent-explain', label: 'Бонус за ясное объяснение родителю', amount: 1 },
      { id: 'neat-mini-atlas', label: 'Бонус за аккуратный мини-атлас', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: [
      'reading-review-words',
      'oral-defense-reading',
      'math-week5-review',
      'atlas-cover-plan',
      'nature-safety-sort',
      'data-atlas-graph',
      'project-mini-nature-atlas',
      'spelling-review',
      'speech-atlas-defense'
    ],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-9-day-1'
};

export default day5;
